import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {FormControl} from "@angular/forms";
import {HtmlTekst} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {RiktekstRedigeringKomponent} from "./riktekst-redigering";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

/**
 * Komponent for redigering av rik tekst.
 * Benytter Tiptip som underliggende rik-tekst-redigeringsrammeverk, se https://tiptap.dev.
 * Merk at ngx-tiptap (angular-bindingen for tiptap) > ver 11 krever angular 19, kan derfor ikke oppgradere til nyeste
 * ver av ngx-tiptap før vi er på angular 19.
 *
 * https://taiga-family.github.io/editor/starter-kit
 * https://github.com/taiga-family/editor
 */
@Component({
    selector: 'riktekst-redigering-ajs',
    template: '<riktekst-redigering [skjemakontroll]="kontroll"/>',
    standalone: true,
    host: {'(click)':'$event.preventDefault()'}, //uten denne bobler klikk og fører til form submit i ajs
    imports: [
        RiktekstRedigeringKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiktekstRedigeringAjsKomponent implements OnInit {
    static ajsSelector = 'riktekstRedigeringAjs';

    //tekst = input.required<HtmlTekst | null>()
   // tekstChange = output<HtmlTekst | null>()

    @Input() set tekst(tekst:string) {
        console.log('# setter tekst', tekst == this.kontroll.value, tekst);
        //dersom angitt tekst er lik tekst i editor oppdaterer vi ikke editor.
        //ved bla klikk på 'ny lenke' i editor skjer det et kall til 'set tekst' med samme verdi som kontroller allerede har,
        //i slike tilfeller er det viktig av kontrollerens verdi ikke blir satt da dette bla vil føre til at 'ny lenke' dialogen lukkes
        if (tekst == this.kontroll.value) return;
        this.kontroll.setValue(tekst, {emitEvent:false})
    }

    @Output() tekstChange = new EventEmitter<HtmlTekst | null>();

    kontroll = new FormControl<HtmlTekst | null>('')

    constructor() {
        //toObservable(this.tekst).pipe(takeUntilDestroyed()).subscribe(tekst => this.kontroll.setValue(tekst, {emitEvent:false}));

        this.kontroll.valueChanges.pipe(takeUntilDestroyed()).subscribe(tekst => {
            console.log('# skriver tekst', tekst);
            this.tekstChange.emit(tekst)
        });
    }

    ngOnInit() {

    }
}
